import type { ServiceCategory } from '@/data/services';

export interface Project {
  id: string;
  title: string;
  category: ServiceCategory;
  city: string;
  year: number;
  description: string;
  image: string;
}

// TODO: Mit echten Projektfotos und Beschreibungen ersetzen.
export const projects: Project[] = [
  {
    id: 'p1',
    title: 'Kronenrückschnitt einer 120-jährigen Eiche',
    category: 'baumpflege',
    city: 'Ahrensburg',
    year: 2024,
    description:
      'Schonender Rückschnitt mit Seilklettertechnik – ohne Hubarbeitsbühne, ohne Bodenschäden im Vorgarten.',
    image: '/images/begutachtung.jpg',
  },
  {
    id: 'p2',
    title: 'Notfällung nach Sturm – Birke auf Carport',
    category: 'baumfaellung',
    city: 'Hamburg',
    year: 2024,
    description: 'Stückweises Abtragen einer abgebrochenen Birke direkt über parkenden Fahrzeugen.',
    image: '/images/hero-climber.jpg',
  },
  {
    id: 'p3',
    title: 'Familienbaumhaus in Buche',
    category: 'baumhausbau',
    city: 'Bargteheide',
    year: 2023,
    description:
      'Konstruktion mit baumschonenden Befestigungen, Plattform 3,5 m über Grund, integriertes Geländer.',
    image: '/images/placeholder-baumhaus.jpg',
  },
  {
    id: 'p4',
    title: 'Lichtraumprofilschnitt entlang Wohnstraße',
    category: 'baumpflege',
    city: 'Reinbek',
    year: 2024,
    description: 'Freischnitt nach FLL für sicheren Begegnungsverkehr zwischen LKW und Radweg.',
    image: '/images/seilklettern.jpg',
  },
  {
    id: 'p5',
    title: 'Stubbenfräsen nach Robinienfällung',
    category: 'baumfaellung',
    city: 'Lübeck',
    year: 2023,
    description:
      'Vollständige Entfernung des Stubbens auf 25 cm unter Grasnarbe, sauberes Verfüllen.',
    image: '/images/placeholder-stubben.jpg',
  },
  {
    id: 'p6',
    title: 'Kronensicherung mit Cobra-System',
    category: 'baumpflege',
    city: 'Hamburg-Wandsbek',
    year: 2024,
    description:
      'Dynamische Kronensicherung in einer Linde mit Zwiesel statt Kappung – Erhalt des Habitus.',
    image: '/images/totholz.jpg',
  },
];
